export const IE11 = '11';

export const isBelowIE11 = browser => {
  const [major] = browser.version.split('.').map(Number);

  return browser && browser.name === 'ie' && major < Number(IE11);
};
